export default __webpack_public_path__ + "static/media/weekly_questions_empty.5f31056d.svg";